import { Card } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  background: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: 50,
    paddingRight: 50,
    paddingTop: 80,
    paddingBottom: 80,

    [theme.breakpoints.down("md")]: {
      paddingTop: 10,
      paddingLeft: 10,
      paddingRight: 10,
      paddingBottom: 10,
    },
  },
  heading: {
    color: theme.palette.pbr.heading,
    textAlign: "center",
    fontSize: 36,
    fontWeight: 600,
    verticalAlign: "middle",
    wordSpacing: "0px",
    paddingTop: 50,
    marginBottom: 40,

    [theme.breakpoints.down("sm")]: {
      fontSize: 28,
    },
  },
  para: {
    color: theme.palette.pbr.textPrimary,
    fontWeight: 600,
    fontSize: 18,
    verticalAlign: "baseline",
    letterSpacing: "-0.8px",
    margin: 0,
    paddingBottom: 15,
    textAlign: "center",
  },

  imageWrapper: {
    padding: 10,
    height: "45px",
    [theme.breakpoints.down("md")]: {
      height: "45px",
      padding: 15,
    },
  },
  imageWrapperDotOracle: {
    padding: 2,
    height: "45px",
    [theme.breakpoints.down("md")]: {
      height: "45px",
      padding: 5,
    },
  },
  imageWrapperMetis: {
    padding: 2,
    height: "45px",
    width: "fit-content",
    [theme.breakpoints.down("md")]: {
      padding: 2,
      height: "30px",
      width: "100%",
    },
  },
  imageWrapperMeland: {
    height: "60px",

    [theme.breakpoints.down("md")]: {
      height: "60px",
      padding: 5,
    },
  },
  imageWrapperUnifarm: {
    padding: 10,
    height: "45px",
    [theme.breakpoints.down("md")]: {
      height: "45px",
      padding: 10,
    },
  },
  imageWrapperKitsumon: {
    padding: 2,
    height: "55px",
    width: "fit-content",
    [theme.breakpoints.down("md")]: {
      padding: 2,
      height: "30px",
      width: "100%",
    },
  },
  imageWizarre: {
    padding: 5,
    height: "55px",
    width: "fit-content",
    [theme.breakpoints.down("md")]: {
      padding: 2,
      height: "35px",
      width: "100%",
    },
  },
  imageWrapperBMW: {
    padding: 5,
    height: "45px",
    paddingLeft: 2,
    paddingRight: 2,
    [theme.breakpoints.down("md")]: {
      height: "45px",
      padding: 5,
      paddingLeft: 2,
      paddingRight: 2,
    },
  },
  imageWrapper2: {
    padding: 10,
    height: "65px",
    [theme.breakpoints.down("md")]: {
      height: "40px",
      padding: 4,
    },
  },

  listItem: {
    alignSelf: "center",
    justifySelf: "center",
  },
  card: {
    padding: 5,
    backgroundColor: "#e5e5e5",
    borderRadius: 12,
    width: "fit-content",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: 50,
      width: 100,
    },
  },
  cardCasper: {
    padding: 5,
    backgroundColor: "#e5e5e5",
    borderRadius: 12,
    [theme.breakpoints.down("md")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: 50,
      width: 140,
    },
  },
  cardWrapper: {
    padding: 5,
  },
  logoContainer: {
    borderRadius: 14,
    paddingTop: 20,
    paddingBottom: 20,
    display: "flex",
    justifyContent: "center",
  },
  logoWrapper: {
    width: 850,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}));

const Investor = () => {
  const classes = useStyles();

  return (
    <div className={classes.background}>
      <h6 className={classes.heading}>
        Investors and Partners<strong className={classes.highlight}></strong>
      </h6>
      <div className={classes.logoContainer}>
        <div className={classes.logoWrapper}>
          <div className="row justify-content-center">
            <div className="col-6 col-md-3 mb-4" align="center">
              <Card className={classes.card}>
                <a className={classes.listItem} href="https://bscscan.com/token/0x23799d7f65961334d75e8c87b39a47b00c76fee2">
                  <img
                    src="assets/binance.png"
                    alt="logo"
                    className={classes.imageWrapper}
                  />
                </a>
              </Card>
            </div>
            <div className="col-6 col-md-3 mb-4" align="center">
              <Card className={classes.card}>
                <a className={classes.listItem} href="#">
                  <img
                    src="assets/icoholder.png"
                    alt="logo"
                    className={classes.imageWrapper}
                  />
                </a>
              </Card>
            </div>
            <div className="col-6 col-md-3 mb-4" align="center">
              <Card className={classes.card}>
                <a className={classes.listItem}>
                  <img
                    src="assets/coinsniper.png"
                    alt="logo"
                    className={classes.imageWrapperBMW}
                  />
                </a>
              </Card>
            </div>
            <div className="col-6 col-md-3 mb-4" align="center">
              <Card className={classes.card}>
                <a className={classes.listItem} href="https://memecoins.club/0x23799d7f65961334d75e8c87b39a47b00c76fee2">
                  <img
                    src="assets/memecoin.png"
                    alt="logo"
                    className={classes.imageWrapper}
                  />
                </a>
              </Card>
            </div>   
            <div className="col-6 col-md-3 mb-4" align="center">
              <Card className={classes.card}>
                <a className={classes.listItem} href="https://pancakeswap.finance/swap#/swap?outputCurrency=0x23799d7f65961334d75e8c87b39a47b00c76fee2">
                  <img
                    src="assets/pancakeswap.png"
                    alt="logo"
                    className={classes.imageWrapper}
                  />
                </a>
              </Card>
            </div>
            <div className="col-6 col-md-3 mb-4" align="center">
            <Card
                className={classes.card}
                style={{
                  backgroundColor: "#212121",
                  border: "1px solid #e5e5e5",
                }}
              >
                <a className={classes.listItem}>
                  <img
                    src="assets/Cointelegraph.webp"
                    alt="logo"
                    className={classes.imageWrapper}
                  />
                </a>
              </Card>
            </div>
            <div className="col-6 col-md-3 mb-4" align="center">
            <Card
                className={classes.card}
                style={{
                  backgroundColor: "#212121",
                  border: "1px solid #e5e5e5",
                }}
              >
                <a
                  className={classes.listItem}
                  href="#"
                >
                  <img
                    src="assets/coinsbit.png"
                    alt="logo"
                    className={classes.imageWrapper}
                  />
                </a>
              </Card>
            </div>
            <div className="col-6 col-md-3 mb-4" align="center">
              <Card className={classes.card}>
                <a className={classes.listItem} href="https://dappradar.com/binance-smart-chain/defi/peacock">
                  <img
                    src="assets/dappradar.png"
                    alt="logo"
                    className={classes.imageWrapper}
                    />
                    </a>
                  </Card>
                </div>           
            <div className="col-6 col-md-3 mb-4" align="center">
              <Card className={classes.card}>
                <a
                  className={classes.listItem}
                  href="#"
                >
                  <img
                    src="assets/CoinGenko.png"
                    alt="logo"
                    className={classes.imageWrapperDotOracle}
                  />
                </a>
              </Card>
            </div>           
            <div className="col-6 col-md-3 mb-4" align="center">
              <Card className={classes.card}>
                <a
                  className={classes.listItem}
                  href="#"
                >
                  <img
                    src="assets/CoinMarketCap.png"
                    alt="logo"
                    className={classes.imageWrapperDotOracle}
                  />
                </a>
              </Card>
            </div>           

            <div className="col-6 col-md-3 mb-4" align="center">
              <Card className={classes.card}>
                <a className={classes.listItem} href="#">
                  <img
                    src="assets/certik.png"
                    alt="logo"
                    className={classes.imageWrapper}
                  />
                </a>
              </Card>
            </div>

            <div className="col-6 col-md-3 mb-4" align="center">
              <Card
                className={classes.card}
                style={{
                  backgroundColor: "#212121",
                  border: "1px solid #e5e5e5",
                }}
              >
                <a className={classes.listItem} href="#">
                  <img
                    src="assets/coinmoonhunt.png"
                    alt="logo"
                    className={classes.imageWrapperMetis}
                  />
                </a>
              </Card>
            </div>
            <div className="col-6 col-md-3 mb-4" align="center">
              <Card
                className={classes.card}
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #e5e5e5",
                }}
              >
                <a className={classes.listItem} href="#">
                  <img
                    src="assets/coinmooner.svg"
                    alt="logo"
                    className={classes.imageWrapper}
                  />
                </a>
              </Card>
            </div>             
              
            <div className="col-6 col-md-3 mb-4" align="center">
              <Card className={classes.card}>
                <a className={classes.listItem} href="#">
                  <img
                    src="assets/hotbit.png"
                    alt="hotbit"
                    className={classes.imageWizarre}
                  />
                </a>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Investor;
